module.exports = __webpack_public_path__ + "static/img/helpingHandBackground1.ce4c0bd0.png";